/* eslint-disable import/prefer-default-export */
import { CSSProperties } from 'react';

import COLORS from '~/constants/colors';

import { Dim } from '../../../models';
import { getNoteDims } from '../../../helpers';
import { THRESHOLD_COLORS } from './constants';

export const getNoteThemes = (
  windowDims: Dim
): Record<string, CSSProperties> => {
  const getNoteBoxShadow = (c = COLORS.black25, d = 10) => {
    const matches = c.match(/\w\w/g) ?? [];
    const [r, g, b, a] = matches.map((v) => parseInt(v, 16));
    const color = `rgba(${r}, ${g}, ${b}, ${a ? a / 255 : 1})`;

    return `0 0 ${Math.round(getNoteDims(windowDims).w / d)}px 0 ${color}`;
  };

  return {
    center: {
      color: COLORS.black,
      backgroundImage: `radial-gradient(${COLORS.yellowGreen} 80%, ${COLORS.white} 80%)`,
      backgroundColor: COLORS.yellowGreen,
      boxShadow: getNoteBoxShadow(),
    },
    lateral: {
      color: COLORS.black,
      backgroundImage: `linear-gradient(135deg, ${COLORS.white} 10%, ${COLORS.hotPink} 10%, ${COLORS.hotPink} 90%, ${COLORS.white} 90%)`,
      backgroundColor: COLORS.hotPink,
      boxShadow: getNoteBoxShadow(),
    },
    medial: {
      color: COLORS.black,
      backgroundImage: `linear-gradient(225deg, ${COLORS.white} 10%, ${COLORS.malibu} 10%, ${COLORS.malibu} 90%, ${COLORS.white} 90%)`,
      backgroundColor: COLORS.malibu,
      boxShadow: getNoteBoxShadow(),
    },
    special: {
      color: COLORS.white,
      backgroundImage: `radial-gradient(${COLORS.mineShaft} 60%, ${COLORS.codGray} 60%, ${COLORS.codGray} 80%, ${COLORS.black} 80%)`,
      backgroundColor: COLORS.codGray,
      boxShadow: getNoteBoxShadow(COLORS.white25),
    },

    // Threshold states
    perfect: {
      color: THRESHOLD_COLORS.perfect,
      backgroundImage: undefined,
      backgroundColor: THRESHOLD_COLORS.perfect,
      boxShadow: getNoteBoxShadow(THRESHOLD_COLORS.perfect, 4),
    },
    good: {
      color: THRESHOLD_COLORS.good,
      backgroundImage: undefined,
      backgroundColor: THRESHOLD_COLORS.good,
      boxShadow: getNoteBoxShadow(THRESHOLD_COLORS.good, 4),
    },
    okay: {
      color: THRESHOLD_COLORS.okay,
      backgroundImage: undefined,
      backgroundColor: THRESHOLD_COLORS.okay,
      boxShadow: getNoteBoxShadow(THRESHOLD_COLORS.okay, 4),
    },
    bad: {
      color: THRESHOLD_COLORS.bad,
      backgroundImage: undefined,
      backgroundColor: THRESHOLD_COLORS.bad,
      boxShadow: getNoteBoxShadow(THRESHOLD_COLORS.bad, 4),
    },
    awful: {
      color: THRESHOLD_COLORS.awful,
      backgroundImage: undefined,
      backgroundColor: THRESHOLD_COLORS.awful,
      boxShadow: getNoteBoxShadow(THRESHOLD_COLORS.awful, 4),
    },
    pre: {
      color: THRESHOLD_COLORS.pre,
      backgroundImage: undefined,
      backgroundColor: THRESHOLD_COLORS.pre,
      boxShadow: getNoteBoxShadow(THRESHOLD_COLORS.pre, 4),
    },

    // Error states
    miss: {
      color: THRESHOLD_COLORS.miss,
      backgroundImage: undefined,
      backgroundColor: COLORS.alto,
      boxShadow: getNoteBoxShadow(),
    },
    wrong: {
      color: COLORS.peanut,
      backgroundImage: undefined,
      backgroundColor: COLORS.mandy,
      boxShadow: getNoteBoxShadow(COLORS.mandy, 4),
    },
  };
};
